//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_degreesPerRadian = 57.29577951308232;\n\
";
